import { render } from "./DoctorList.vue?vue&type=template&id=4f8a722c&scoped=true"
import script from "./DoctorList.vue?vue&type=script&lang=js"
export * from "./DoctorList.vue?vue&type=script&lang=js"

import "./DoctorList.vue?vue&type=style&index=0&id=4f8a722c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8a722c"]])

export default __exports__